// API wrappers for Custom Channels — external community / forum / Q&A
// platforms a brand engages on (Skool, Reddit, Quora, Indie Hackers, niche
// forums, …). The backend route is mounted at /api/custom-channels and
// reuses the brand-settings permission gate. Secrets (login password) are
// never returned; the server surfaces a `_hasPassword` flag instead.
//
// Every wrapper is a thin pass-through to the shared fetch helpers in
// ../index so it can be unit-tested by mocking that module.
import { post, get, globalPut, remove } from "../index";

const BASE = "/api/custom-channels";

// ---- CRUD ----------------------------------------------------------------

export const listCustomChannels = (brandId) =>
  get(`${BASE}${brandId ? `?brand_id=${encodeURIComponent(brandId)}` : ""}`);

export const getCustomChannel = (id) => get(`${BASE}/${id}`);

export const createCustomChannel = (data) => post(BASE, data, false);

export const updateCustomChannel = (id, data) =>
  globalPut(`${BASE}/${id}`, data, false);

export const deleteCustomChannel = (id) => remove(`${BASE}/${id}`);

// ---- Topics --------------------------------------------------------------

// Manually attach a relevant thread/topic to a channel (the crawler adds
// these automatically; this is the manual path).
export const addCustomChannelTopic = (id, topic) =>
  post(`${BASE}/${id}/topics`, topic, false);

// ---- Engagement actions (worker-backed) ---------------------------------

// "Crawl now" — immediate per-platform search for relevant threads.
export const crawlCustomChannel = (id) => post(`${BASE}/${id}/crawl`, {}, false);

// "Discover platforms now" — internet-wide discovery of new platforms for a
// brand (the scheduler also does this weekly).
export const discoverCustomChannels = (brandId) =>
  post(`${BASE}/discover`, { brand_id: brandId }, false);

// Ask the worker for an AI-drafted reply to a post/topic. Creates a pending
// reply-history row and returns its replyId; the worker fills in the text.
export const requestAiReply = (id, body) =>
  post(`${BASE}/${id}/ai-reply`, body, false);

// Edit a draft reply's text/image before sending.
export const updateReply = (id, replyId, body) =>
  globalPut(`${BASE}/${id}/replies/${replyId}`, body, false);

// Send a reviewed reply — the worker posts it to the platform and keeps it
// in history for monitoring.
export const sendReply = (id, replyId, body) =>
  post(`${BASE}/${id}/replies/${replyId}/send`, body || {}, false);

// Reply history (the monitoring tab).
export const getReplyHistory = (id) => get(`${BASE}/${id}/history`);
